import { HttpContext } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { IGNORAR_ERRO_GLOBAL } from '@core/services/api/interceptor';
import { BaseCrud } from '../helpers/baseCrud';
import { ApiEndpointService } from '../../api-endpoint.service';
import { EstadoOnboarding, RespostaExercicio, ResultadoExercicio } from '@core/onboarding/onboarding.model';

@Injectable({ providedIn: 'root' })
export class OnboardingRoute extends BaseCrud {
  constructor() { super(inject(ApiEndpointService)); }

  getUrl(): string { return `${this.api.getApiUrl()}/onboarding`; }

  carregar(): Observable<EstadoOnboarding> {
    return this.api.getHttp().get<EstadoOnboarding>(this.getUrl(), { context: this.contexto() });
  }

  guia(modo: 'guiado' | 'pausado', capitulo: string): Observable<EstadoOnboarding> {
    return this.post<EstadoOnboarding>('guia', { modo, capitulo });
  }

  exercicio(id: string, resposta: RespostaExercicio): Observable<ResultadoExercicio> {
    return this.post<ResultadoExercicio>(`exercicios/${encodeURIComponent(id)}`, { resposta });
  }

  preferencia(ativo: boolean): Observable<EstadoOnboarding> { return this.post<EstadoOnboarding>('preferencia', { ativo }); }
  concluirOrientacao(capitulo: string): Observable<EstadoOnboarding> {
    return this.post<EstadoOnboarding>(`orientacoes/${encodeURIComponent(capitulo)}`, {});
  }
  verificar(): Observable<EstadoOnboarding> { return this.post<EstadoOnboarding>('verificar', {}); }
  plano(segmento: string, modeloContabil?: 'micro' | 'pequena'): Observable<EstadoOnboarding> {
    return this.post<EstadoOnboarding>('plano', { segmento, ...(modeloContabil ? { modelo_contabil: modeloContabil } : {}), confirmado: true });
  }
  celebrar(): Observable<EstadoOnboarding> { return this.post<EstadoOnboarding>('celebrar', {}); }

  private post<T>(caminho: string, corpo: object): Observable<T> {
    return this.api.getHttp().post<T>(`${this.getUrl()}/${caminho}`, corpo, { context: this.contexto() });
  }

  private contexto(): HttpContext { return new HttpContext().set(IGNORAR_ERRO_GLOBAL, true); }
}
